
$(function(){
    $('.list-filters select').on('change' , function(){
        var theFilters = $(this).closest('.list-filters');
        var target = theFilters.data('target');
        var thePartial = $(`.partial[data-partial="${target}"]`);
        var key = $(this).attr('name');
        var val = $(this).val(); 
        thePartial.data('page',1);
        thePartial.data(key,val);
        load_partial(thePartial);
    });
})
function jumpInPagination($link, page) {
    let $partial = $link.closest('.partial');
    $partial.data('page', page);
    partialPager($link, page);
}  
function initForm( target ) {
    'use strict';
    var t = typeof(target)!=='undefined' ? target : 'body';    
    
    $(t).find('.partial').each(function(){
        var $thePartial = $(this);
        if(!$thePartial.hasClass('muted')){
            load_partial( $thePartial);
        }
    });


    if ( $(t).find( "textarea.editor" ).length > 0 ) {                   
        $(t).find( "textarea.editor" ).each( function( ) {             
            if(typeof CKEDITOR !=='undefined'){            
                CKEDITOR.replace( $( this ).attr( 'id' ), {
                    allowedContent: true,
                    entities_greek: false,
                    removePlugins: 'easyimage, cloudservices',
                    on: {
                        instanceReady: function( evt ) {
                            var editor = evt.editor,
                                body = editor.document.getBody( );
                            body.setAttribute( 'class', 'skin-guide' );
                        }
                    }
                });            
            }
        });
    }

    if ( $(t).find( ".slider" ).length > 0 ) { 


        $(t).find( ".form-group-rating .slider" ).each(function(){
            var $thisSlider = $(this);
			var name = $thisSlider.data('name');
            var id = $thisSlider.attr('id');
			var $range = new Object();
			var $range_raw = $thisSlider.data('range').split(",");
			var $range_raw_lenght = $range_raw.length
            var slider = document.getElementById(id);


			for(var $i = 0; $i < $range_raw_lenght; $i++){
				if($i == 0){
					$range.min = Number($range_raw[$i]);
				}else if($i == $range_raw_lenght-1){
					$range.max = Number($range_raw[$i]);
				}
				var index = ($i*100)/($range_raw_lenght-1);					
				$range[index+'%'] = Number($range_raw[$i]);			
			}



			
			var $slap = false;
			if($thisSlider.data('slap') == '1'){
				$slap = true;
			}
			if(typeof $thisSlider.data('start') !== 'undefined' ){				
				var start = $thisSlider.data('start'); 
			}else{ 
				var start = $range['min'];
			} 

            var options = {
                snap:  $slap,
                step: 1,
                range: $range,
                connect: 'lower',
                format: wNumb({
                    decimals: 0
                }),				
                start: start,
                pips: {mode: 'count', values: 5}			
            };
            noUiSlider.create( slider, options);    

            slider.noUiSlider.on('update', function (values, handle) {			              
                $thisSlider.closest('.form-group-rating').find('input').val(parseFloat(values[0].toString())).trigger('change');                
            });
        });
    }    

    $(t).find( '.select2, select[data-plg="select2"]' ).each( function( ) {
        var data = $( this ).data( );
        var _this = $( this );
        var options = {
            templateResult: resultState
        };
        if ( data.ajax ) {
            options = $.extend( false, options, {
                placeholder: data.placeholder,
                allowClear: data.allowClear || false,
                ajax: {
                    url: API + '/' + data.ajax,
                    dataType: 'json',
                    delay: 250,
                    data: function( params ) {
                        var search_for = typeof( params.term ) !== 'undefined' ? params.term : '';
                        return {
                            q: data.search + '=@' + search_for,
                            page: params.page
                        };
                    }, 
                    processResults: function( res, params ) {
                        params.page = params.page || 1;
                        var value_field = data.value || 'id';
                        var label_field = data.label || data.search;
                        return {
                            results: $.map( res.data, function( item ) {
                                return {
                                    all_data: item,
                                    text: item[ label_field ],
                                    id: item[ value_field ]
                                }
                            } ),
                            pagination: {
                                more: ( params.page * 30 ) < data.total_count
                            }
                        };
                    },
                    cache: true
                },
                minimumInputLength: 0
            } );
        }           

        if ( _this.data( 'selected_value' ) ) {
            var dd = {};

            dd[ data.value || 'id' ] = _this.data( 'selected_value' );

            $.ajax( {
                url: API + '/' + data.ajax,
                dataType: 'json',
                data: dd,
                error: function( ) {},
                success: function( res ) {
                    var value_field = data.value || 'id';
                    var label_field = data.label || data.search;
                    _this.html( '<option value="' + res.data[ 0 ][ value_field ] + '">' + res.data[ 0 ][ label_field ] + '</option>' );
                    _this.select2( options );
                }
            } );
        }

        $(this).select2(options).on('select2:open', function () {
            $(this).closest('.form-group').addClass('filled');
            $('.select2-dropdown').closest('.select2-container').addClass('z-index-dropdown');
        }).on('select2:close', function () {
            if( $(this).val() == '0' || $(this).val() == '' || $(this).val() == 'undefined' || $(this).val() == null ){
                $(this).closest('.form-group').removeClass('filled');
            }   
            $('.select2-dropdown').closest('.select2-container').removeClass('z-index-dropdown'); 
        });

    });  

    $(t).find(".form-group" ).each( function( ) {
        var $formGroup = $(this);
        if(!$formGroup.hasClass('eventReady')){
            $formGroup.click(function() {                     
                if($formGroup.find('.select2,select[data-plg="select2"]').length>0){                    
                    $formGroup.find('select.select2-hidden-accessible ').select2('open')

                }else{   
                    $formGroup.find('.form-control').focus();                    
                }
            });

            if( typeof $formGroup.find(".form-control" ).val()!=='undefined' && $formGroup.find(".form-control" ).val()!=='' ){
                $formGroup.find(".form-control" ).closest(".form-group").addClass('filled');
            }

            $formGroup.find(".form-control" ).focusin(function() {
                $(this).closest(".form-group").addClass('filled');
            }).focusout(function() {       
                if($(this).val()=='')  {
                     $(this).closest(".form-group").removeClass('filled');   
                }  
            });
            $formGroup.addClass('eventReady');

        }
        
    });

    $(t).find('input.datepicker').each( function( ) {
        if(typeof $(this).data('config')!=='undefined'){
            var datepicker = $(this).datepicker($(this).data('config'));
        }else{
            var datepicker = $(this).datepicker();
        }   

         if( typeof($(this).data('config')['link_from'])!='undefined' ){
            var _this =$(this);
            datepicker.on('hide', function(ev) { 
               _this.closest(".item-row").find('input[name="'+_this.data('config')['link_from']+'"]').datepicker( "setEndDate", ev.date );
            });
        }    

        if( typeof($(this).data('config')['link_to'])!='undefined' ){
            var _this =$(this);
             datepicker.on('hide', function(ev) { 
               _this.closest(".item-row").find('input[name="'+_this.data('config')['link_to']+'"]').datepicker( "setStartDate", ev.date );
            });
        }    

    });

    waypoints( );
}

function resultState(data, container) {
    if(data.element) {
        $(container).addClass($(data.element).attr("class"));
    }
    return data.text;
}

function actionResponseModal( msg, type, container , cb ) {
    var $timeout = 0;

    /*if($('body').hasClass('modal-open') ){
      $('.modal').modal('hide');
      $timeout = 500;  
    }*/

    var with_ajax_modal = false;
    if ( $( '#ajaxModal:visible' ).length == 1 ) {
        with_ajax_modal = true;
        $( '#ajaxModal' ).animate( {
            opacity: 0
        }, 300 );
    }

    setTimeout( function( ) {        
        var $d =  `<div class="modal fade" id="responseModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-md" role="document">
                            <div class="modal-content">
                                <a href="#" class="close-modal" tabindex="0" onClick="$('#responseModal').modal('hide');return false;">
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" viewBox="0 0 13 13" style="enable-background:new 0 0 13 13;" xml:space="preserve">
                                        <path class="st0" d="M12.9,11.7l-1.2,1.2L6.9,8.1l-4.8,4.8l-1.2-1.2l4.8-4.8L0.9,2.1l1.2-1.2l4.8,4.8l4.8-4.8l1.2,1.2L8.1,6.9 L12.9,11.7z"></path>
                                    </svg>
                                </a>
                                <div class="modal-body"></div>
                            </div>
                        </div>
                    </div>`;

        if ( $( '#responseModal' ).length == 0 ) {
            $( 'body' ).append( $d );
        }

        var _container = container || '';
        if ( type == 'success' ) {
            var icon = `<i class="fa fa-check-circle" aria-hidden="true"></i>`;
        } else {
            var icon = `<i class="fa fa-exclamation-circle" aria-hidden="true"></i>`;
        }
        var content = '<div class="alert alert-' + type + '"><h3>' + msg + '</h3></div>'
        $( '#responseModal .modal-body' ).html( content );
        $( 'body' ).addClass( 'dark-backdrop' );
        $( '#responseModal' ).modal( 'show' ).on( 'hidden.bs.modal', function( ) {

            $( '#responseModal .modal-body' ).empty( );
            $( 'body' ).removeClass( 'dark-backdrop' );
            if ( with_ajax_modal ) {
                $( '#ajaxModal' ).animate( {
                    opacity: 1
                }, 300 );
            }
        } ).on( 'shown.bs.modal', function( ) {            
            
            setTimeout(function(){
                if($( '#responseModal' ).hasClass('show')){
                    $( '#responseModal' ).modal('hide');
                }
            },5000)
        });;
    }, $timeout );    
}

var AjaxForms = {

    options : {
        target        : null,
        stop_response : false,
        empty_form       : true,
        successFn     : null,
        errorFn       : null,
        method        : 'POST',
        recaptcha     : false
    },
    
    init:function(t){
        var $this = this; 
        if($this.options.recaptcha ===  true){

            var recaptcha_lang = typeof($('html').attr('lang') !== 'undefined') ? $('html').attr('lang') :'en';
            $.ajax({
                url: 'https://www.google.com/recaptcha/api.js?hl='+recaptcha_lang,
                dataType: "script",
                success:function(){
                    try{
                        grecaptcha.remder();
                    }catch (Error){}
                }
            });
        }

        $this.options.target = t;
        $($this.options.target).parsley({
            excluded: "textarea:hidden, input:hidden, select:hidden",
            classHandler: function (el) {
                return el.$element.closest('.form-group,.option-form-group'); //working
            },
        });
        



        $($this.options.target).on('submit',function($e){         
           

            if(typeof CKEDITOR !== 'undefined' && CKEDITOR){
                for ( instance in CKEDITOR.instances ){
                    CKEDITOR.instances[ instance ].updateElement( );
                }
            }



            $this.submit_form();
            $e.preventDefault(); 

        }).addClass('ready');
    },
   
    submit_form:function(){

        var $this       = this,
            $form       = $($this.options.target),
            successFn   = $this.options.successFn,
            errorFn     = $this.options.errorFn,
            url         = $form.attr('action'),
            postData    = $form.serialize(),
            method      = $form.attr('method'),
            $submitBTN  = $form.find('button[type="submit"]');
      
        $submitBTN.prop('disabled',true);
        $submitBTN.data('initialText',$submitBTN.html());
        $submitBTN.html('<i class="fa fa-spinner fa-spin"></i> '+ ['working on it']);     
        
      

        $.ajax({
            url     : url,
            data    : postData,
            type    : method,
            dataType : 'json',
            success: function (data) {            
                
                if($this.options.recaptcha ===  true){
                    grecaptcha.reset();
                }                
                $submitBTN.html($submitBTN.data('initialText'));               
                if($this.options.empty_form){
                    $form.find('input,textarea,select').not(':hidden').each(function(){
                        $(this).val('');
                        $(this).closest('.form-group').removeClass('parsley-success');
                    });  
                    if(typeof CKEDITOR !== 'undefined' && CKEDITOR){
                        for ( instance in CKEDITOR.instances ){
                            CKEDITOR.instances[ instance ].setData('') 
                            CKEDITOR.instances[ instance ].updateElement( );
                        }
                    }
                } 

                if(typeof(successFn) !== 'undefined'){
                    successFn(data);
                }                
                console.log(data);
                if(!$this.options.stop_response){
                    $this.form_submit_response( data.message || 'submitted', 'success');        
                }
            },
            error: function (response) {                
                if($this.options.recaptcha ===  true){
                    grecaptcha.reset();
                }
                $submitBTN.prop('disabled',false);    
                var responseJSON = jQuery.parseJSON(response.responseText);
                
                $submitBTN.html($submitBTN.data('initialText'));

                if(typeof(errorFn) !== 'undefined'){
                    errorFn( responseJSON );
                }else{
                    for(var i in responseJSON.errors){ 
                        if(i == 'g-recaptcha-response'){
                            return actionResponseModal('Are you a robot?','error');
                        }else{
                            var t = $form.find('[name="'+i+'"]').closest('.form-group');                            
                            $form.find('[name="'+i+'"]').closest('.form-group').addClass('parsley-error');
                            var error_string = typeof( responseJSON.errors[i]) ==='string' ?  responseJSON.errors[i] : responseJSON.errors[i].join('')
                            if(t.find('.parsley-errors-list').length > 0){
                                t.find('.parsley-errors-list').html('<div class="parsley-type" style="color:red">'+error_string+'</div>');
                            }else{

                                t.append('<div class="parsley-errors-list filled text-left" style="color:red"><div class="parsley-type">'+error_string+'</div></div>');    
                            }

                        }
                    }

                    $this.form_submit_response( responseJSON.error || responseJSON.message || 'error', 'error');
                }
            }
        });
    },
    form_submit_response : function( msg , type){
        actionResponseModal(msg,type);
    }
}

function inlineUploader(id,name) { 
    
    var target ='uploader-'+id;
    var uploader = new plupload.Uploader({
        runtimes        : 'html5,flash,silverlight,browserplus',
        browse_button   : target + '-pickfiles',
        container       : target + '-container',
        drop_element    : target + '-dropzone',
        url : "/upload",
        headers:{
            'X-CSRF-TOKEN':$('meta[name="csrf-token"]').attr('content')
        },        
        multipart_params: {
            'key': id
        },
        filters : {
            max_file_size : '10mb',
            mime_types: $('#'+target).data('minetypes')
        }
    });

    uploader.bind('Init', function(up, params) {

    });

    $('#'+target + '-uploadfiles').click(function(e) {
        uploader.start();
        e.preventDefault();
    });

    uploader.init();
  
    uploader.bind('FilesAdded', function(up, files) {
        $.each(files, function(i, file) {
            var markup = `  <div id="${file.id}">                                
                                <div class="progress" style="display:none;">
                                    <div class="progress-bar progress-bar-danger" style="width: 0%;"></div>
                                </div>
                                <small class="no-margin">${file.name} (${plupload.formatSize(file.size)})</small>
                            </div>`;
                            
            $('#'+target + '-uploaded-files').html(markup);
        });
        up.refresh();
        uploader.start();
    });

    uploader.bind('UploadProgress', function(up, file) {
        $('#' + file.id + " .progress").fadeIn('fast');
        $('#' + file.id + " .progress .progress-bar").width(file.percent + "%");
    });
 
    uploader.bind('Error', function(up, err) {
        $('#'+target + '-filelist').append("<div>Error: " + err.code +
            ", Message: " + err.message +
            (err.file ? ", File: " + err.file.name : "") +
            "</div>"
        );


        $('#'+target ).find('.fileinput-button .browse-icon').hide();
        $('#'+target ).find('.fileinput-button .completed-icon').hide();
        $('#'+target ).find('.fileinput-button .error-icon').show();
        $('#'+target ).find('.fileinput-button').removeClass('btn-default').removeClass('btn-success').addClass('btn-danger');


        up.refresh();
    });
    uploader.bind('FileUploaded', function(up, file,ee) {

        var response = (JSON.parse(ee.response));


        $('#'+target ).find('.fileinput-button .browse-icon').hide();
        $('#'+target ).find('.fileinput-button .error-icon').hide();
        $('#'+target ).find('.fileinput-button .completed-icon').show();
        $('#'+target ).find('.fileinput-button').removeClass('btn-default').removeClass('btn-danger').addClass('btn-success');



        $('#' + file.id + " .progress").fadeOut('fast');
        $('#'+target + ' input[name="uploader['+name+']"]').val( response.path);
        $('#'+target + ' input[name="uploader_original_filename['+name+']"]').val( file.name);
    });                   
};  